module.exports = __webpack_public_path__ + "static/media/cilantro.4f8fac07.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/cilantro.jpg
// module id = 123
// module chunks = 0